import { Box, Card, Chip, Icon, IconButton, Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { get } from "utils/WebService";
import CadastroBasico from "./tabs/CadastroBasico";
import Contratos from "./tabs/Contratos";
import Historico from "./tabs/Historico";
import Acordos from "./tabs/Acordos";
import Juridico from "./tabs/Juridico";
import Honorarios from "./tabs/Honorarios";
import Documentos from "./tabs/Documentos";
import HeaderDevedor from "./tabs/HeaderDevedor";

export default function BaseDeDadosCreateEdit({ recordId, idDevedorCarteira, closeCreateEdit, isJuridico, isViewOnly, isFila = false }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const formRef = useRef();
    const [tabValue, setTabValue] = useState(1);
    const [visitedTabs, setVisitedTabs] = useState(new Set([1, 2, 3, 4, 5, 6, 7, 8]));
    const [pendingContratos, setPendingContratos] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [loadingTabs, setLoadingTabs] = useState(true);

    const handleChange = (event, newValue) => {
        let val = newValue !== undefined ? newValue : event;
        setTabValue(val);
        setVisitedTabs(prev => new Set(prev).add(val));
    };

    const [hasProcesso, setHasProcesso] = useState(false);
    const [hasHonorarios, setHasHonorarios] = useState(false);
    const [hasAcordos, setHasAcordos] = useState(false);
    const [hasAcordosHonorarios, setHasAcordosHonorarios] = useState(false);
    const [devedorData, setDevedorData] = useState(null);
    const [allContratos, setAllContratos] = useState([]);
    const [allAcordos, setAllAcordos] = useState([]);
    const [allHistoricos, setAllHistoricos] = useState([]);

    const checkTabVisibility = () => {
        if (!recordId) return;

        get(`/devedor/by-id/${recordId}`).then(res => {
            if (res) {
                setDevedorData(res);
                if (res.nome) {
                    sessionStorage.setItem('activeDevedorId', recordId);
                    sessionStorage.setItem('activeDevedorNome', res.nome);
                    window.dispatchEvent(new Event('sessionStorageUpdate'));
                }
            }
        }).catch(err => console.error(err));

        get(`/acordo/list/${recordId}`).then(res => {
            if (res && Array.isArray(res)) {
                setAllAcordos(res);
                setHasAcordosHonorarios(res.some(a => a.isHonorario === true || a.honorario === true));
            }
        }).catch(err => console.error(err));

        get(`/contratos/list/${recordId}`).then(res => {
            if (res && Array.isArray(res)) setAllContratos(res);
        }).catch(err => console.error(err));

        get(`/devedor/historico/${recordId}`).then(res => {
            if (res && Array.isArray(res)) setAllHistoricos(res);
        }).catch(err => console.error(err));
    };

    useEffect(() => {
        checkTabVisibility();
        
        return () => {
            sessionStorage.removeItem('activeDevedorId');
            sessionStorage.removeItem('activeDevedorNome');
            window.dispatchEvent(new Event('sessionStorageUpdate'));
        };
    }, [recordId]);

    const showProcessos = devedorData?.fichas && Array.isArray(devedorData.fichas) ? devedorData.fichas.some(f => f.isJuridico) : false;
    const showHonorarios = (devedorData?.fichas && Array.isArray(devedorData.fichas) ? devedorData.fichas.some(f => f.isHonorario) : false) || 
                           (Array.isArray(allContratos) ? allContratos.some(c => c.isHonorario === true || c.cbIsHonorario === true) : false) || 
                           hasAcordosHonorarios;

    return (
        <Card id="base-dados-info">
            <Box display="flex" alignItems="center" px={2} pt={2} pb={isViewOnly ? 1 : 2}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 2 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                {recordId && (
                    <MDBox sx={{ flexGrow: 1 }}>
                        <HeaderDevedor recordId={recordId} />
                    </MDBox>
                )}
            </Box>

            <MDBox sx={{ width: '100%', px: 2, mb: 8 }}>
                <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleChange} aria-label="base-dados-tabs">
                        <Tab label="Cadastro Básico" value={1} sx={{ fontSize: 12 }} />
                        <Tab label="Contratos" value={2} sx={{ fontSize: 12 }} />
                        {recordId && showHonorarios && <Tab label="Honorários" value={6} sx={{ fontSize: 12 }} />}
                        {recordId && <Tab label="Histórico" value={3} sx={{ fontSize: 12 }} />}
                        {recordId && <Tab label="Acordos" value={4} sx={{ fontSize: 12 }} />}
                        {recordId && hasAcordosHonorarios && <Tab label="Acordos Honorários" value={7} sx={{ fontSize: 12 }} />}
                        {recordId && showProcessos && <Tab label="Processos" value={5} sx={{ fontSize: 12 }} />}
                        {recordId && <Tab label="Documentos" value={8} sx={{ fontSize: 12 }} />}
                    </Tabs>
                </MDBox>

                <MDBox mt={3}>
                    <div role="tabpanel" hidden={tabValue !== 1} id={`tab-1`}>
                        <CadastroBasico formRef={formRef} recordId={recordId} isJuridico={isJuridico} closeCreateEdit={closeCreateEdit} isViewOnly={isViewOnly} pendingContratos={pendingContratos} refreshKey={refreshKey} preloadedDevedor={devedorData} />
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 2} id={`tab-2`}>
                        {visitedTabs.has(2) && <Contratos formRef={formRef} recordId={recordId} isViewOnly={isViewOnly} isFila={isFila} pendingContratos={pendingContratos} setPendingContratos={setPendingContratos} changeTab={handleChange} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedContratos={allContratos} preloadedAcordos={allAcordos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 6} id={`tab-6`}>
                        {visitedTabs.has(6) && <Honorarios formRef={formRef} recordId={recordId} isViewOnly={isViewOnly} pendingContratos={pendingContratos} setPendingContratos={setPendingContratos} changeTab={handleChange} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedDevedor={devedorData} preloadedContratos={allContratos} preloadedAcordos={allAcordos} preloadedHistoricos={allHistoricos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 3} id={`tab-3`}>
                        {visitedTabs.has(3) && <Historico recordId={recordId} idDevedorCarteira={idDevedorCarteira} isViewOnly={isViewOnly} refreshKey={refreshKey} preloadedDevedor={devedorData} preloadedHistoricos={allHistoricos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 4} id={`tab-4`}>
                        {visitedTabs.has(4) && <Acordos recordId={recordId} isViewOnly={isViewOnly} changeTab={handleChange} isHonorariosTab={false} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedAcordos={allAcordos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 7} id={`tab-7`}>
                        {visitedTabs.has(7) && <Acordos recordId={recordId} isViewOnly={isViewOnly} changeTab={handleChange} isHonorariosTab={true} onDataUpdated={checkTabVisibility} refreshKey={refreshKey} preloadedAcordos={allAcordos} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 5} id={`tab-5`}>
                        {visitedTabs.has(5) && <Juridico recordId={recordId} isViewOnly={isViewOnly} refreshKey={refreshKey} preloadedDevedor={devedorData} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 8} id={`tab-8`}>
                        {visitedTabs.has(8) && <Documentos recordId={recordId} isViewOnly={isViewOnly} />}
                    </div>
                </MDBox>
            </MDBox>
        </Card>
    );
}
